import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { forgeServiceDeskEntrypoint } from '@atlassian/jira-spa-apps-forge-servicedesk-queue/entrypoint.tsx';

export const forgeServiceDeskQueuePageEntrypoint = createPageEntryPoint({
	main: forgeServiceDeskEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
